import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services/config';
import { ShipmentWaybillEndpoint } from '../../constants';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { getQueryStringFromObject, ListServerPaginationStateModel } from '../../../../../common';
import { Observable } from 'rxjs';
import { ShipmentSapDeliveryListSearchCriteria, ShipmentSapDeliveryModel } from '../../../../../common/models';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillSapDeliveriesService {
  constructor(private http: WrapperHttpService) {}

  getShipmentWaybillSapDeliveries(
    searchCriteria: ShipmentSapDeliveryListSearchCriteria,
  ): Observable<ListServerPaginationStateModel<ShipmentSapDeliveryModel>> {
    return this.http
      .withLoading()
      .get<ListServerPaginationStateModel<ShipmentSapDeliveryModel>>(
        `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
          ShipmentWaybillEndpoint.SapDeliveries
        }?${getQueryStringFromObject(searchCriteria.waybillIdView)}&page=${searchCriteria.page}&size=${
          searchCriteria.size
        }`,
        searchCriteria.waybillIdView,
      );
  }
}
